import styled from '@emotion/styled';
import { Dispatch, SetStateAction } from 'react';
import Filter from './Filter';

interface FilterWrapperProps {
  filterState: string;
  setFilterState: Dispatch<SetStateAction<string>>;
}

export default function FilterWrapper({ filterState, setFilterState }: FilterWrapperProps) {
  const FilterDiv = styled('div')`
    text-align: right;
    margin-right: 18px;
  `;

  return (
    <FilterDiv>
      <Filter filterState={filterState} setFilterState={setFilterState} />
    </FilterDiv>
  );
}
